import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    BooleanField,
    Filter,
    List,
    SearchInput,
    BooleanInput,
    ReferenceInput,
    ReferenceField,
    SelectInput,
} from 'react-admin';
import ThumbnailField from './fields/ThumbnailField';
const PostFilter = (props: any) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <BooleanInput
            source="is_published"
            label="resources.posts.fields.is_published"
        />
        <ReferenceInput
            alwaysOn
            emptyText="resources.teams.all"
            label="resources.users.fieldGroups.team"
            source="teams"
            reference="teams"
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput
            allowEmpty
            label="resources.posts.fields.news_type"
            source="news_type"
            reference="news_types"
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);
const PostList = (props: any) => {
    return (
        <List
            {...props}
            filters={<PostFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
        >
            <Datagrid optimized rowClick="edit">
                <ThumbnailField
                    source="image"
                    label="resources.posts.fields.image"
                />
                <TextField
                    source="title"
                    label="resources.posts.fields.title"
                />
                <BooleanField
                    source="is_published"
                    label="resources.posts.fields.is_published"
                />
                <ReferenceField
                    source="news_type"
                    reference="news_types"
                    label="resources.posts.fields.news_type"
                    allowEmpty
                    link={false}
                >
                    <TextField source="name" />
                </ReferenceField>
                <DateField
                    source="publish_at"
                    showTime
                    label="resources.posts.fields.publish_at"
                />
                <DateField
                    source="notif_send_at"
                    showTime
                    label="resources.posts.fields.notif_send_at"
                />
                <BooleanField
                    source="is_daily_content"
                    label="resources.posts.fields.is_daily_content"
                />
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.posts.fields.created_at"
                />
            </Datagrid>
        </List>
    );
};

export default PostList;
